import { translate } from '@utils/i18n';
const namespace = 'features.ai_chat_widget.thoughts';
export const THOUGHT_KEYS = {
    STARTING_TURN: 'ipa.thought.starting_turn',
    GATHERING_CONTEXT: 'ipa.thought.gathering_context',
    RECEIVING_REQUEST: 'ipa.thought.receiving_request',
    WORKING_THROUGH_DETAILS: 'ipa.thought.working_through_details',
    CHOOSING_PATH: 'ipa.thought.choosing_path',
    PREPARING_TO_HELP: 'ipa.thought.preparing_to_help',
    CHECKING_RECORDS: 'ipa.thought.checking_records',
    LOOKUP_SCHEDULE_AND_WORK: 'ipa.thought.lookup_schedule_and_work',
    LOOKUP_LOCATIONS_AND_ACCOUNTS: 'ipa.thought.lookup_locations_and_accounts',
    LOOKUP_COMMERCIAL_RECORDS: 'ipa.thought.lookup_commercial_records',
    LOOKUP_TEAM_AND_ROSTER: 'ipa.thought.lookup_team_and_roster',
    LOOKUP_EQUIPMENT: 'ipa.thought.lookup_equipment',
    LOOKUP_REPORTS_AND_FILES: 'ipa.thought.lookup_reports_and_files',
    REVIEWING_DATA: 'ipa.thought.reviewing_data',
    PREPARING_CHANGE: 'ipa.thought.preparing_change',
    UPDATING_RECORDS: 'ipa.thought.updating_records',
    CREATING_EXPORT: 'ipa.thought.creating_export',
    PREPARING_ANSWER: 'ipa.thought.preparing_answer',
    RESUMING_ACTION: 'ipa.thought.resuming_action'
};
const thoughtLabelKeys = {
    [THOUGHT_KEYS.STARTING_TURN]: 'starting_turn',
    [THOUGHT_KEYS.GATHERING_CONTEXT]: 'gathering_context',
    [THOUGHT_KEYS.RECEIVING_REQUEST]: 'receiving_request',
    [THOUGHT_KEYS.WORKING_THROUGH_DETAILS]: 'working_through_details',
    [THOUGHT_KEYS.CHOOSING_PATH]: 'choosing_path',
    [THOUGHT_KEYS.PREPARING_TO_HELP]: 'preparing_to_help',
    [THOUGHT_KEYS.CHECKING_RECORDS]: 'checking_records',
    [THOUGHT_KEYS.LOOKUP_SCHEDULE_AND_WORK]: 'lookup_schedule_and_work',
    [THOUGHT_KEYS.LOOKUP_LOCATIONS_AND_ACCOUNTS]: 'lookup_locations_and_accounts',
    [THOUGHT_KEYS.LOOKUP_COMMERCIAL_RECORDS]: 'lookup_commercial_records',
    [THOUGHT_KEYS.LOOKUP_TEAM_AND_ROSTER]: 'lookup_team_and_roster',
    [THOUGHT_KEYS.LOOKUP_EQUIPMENT]: 'lookup_equipment',
    [THOUGHT_KEYS.LOOKUP_REPORTS_AND_FILES]: 'lookup_reports_and_files',
    [THOUGHT_KEYS.REVIEWING_DATA]: 'reviewing_data',
    [THOUGHT_KEYS.PREPARING_CHANGE]: 'preparing_change',
    [THOUGHT_KEYS.UPDATING_RECORDS]: 'updating_records',
    [THOUGHT_KEYS.CREATING_EXPORT]: 'creating_export',
    [THOUGHT_KEYS.PREPARING_ANSWER]: 'preparing_answer',
    [THOUGHT_KEYS.RESUMING_ACTION]: 'resuming_action'
};
function isThoughtKey(thoughtKey) {
    if (!thoughtKey)
        return false;
    return Object.values(THOUGHT_KEYS).includes(thoughtKey);
}
function normalizeLabel(label) {
    if (typeof label !== 'string')
        return null;
    const trimmed = label.trim();
    if (!trimmed)
        return null;
    if (trimmed.startsWith('[missing'))
        return null;
    if (trimmed.startsWith('translation missing'))
        return null;
    return trimmed;
}
function translatedVariants(labelKey) {
    const translated = translate(labelKey, { namespace });
    if (Array.isArray(translated)) {
        return translated.map(normalizeLabel).filter((label) => Boolean(label));
    }
    const singleLabel = normalizeLabel(translated);
    return singleLabel ? [singleLabel] : [];
}
function pickVariant(variants, randomSource) {
    if (variants.length === 0)
        return null;
    const randomValue = Math.max(0, Math.min(randomSource(), 0.999999));
    return variants[Math.floor(randomValue * variants.length)];
}
export function defaultThinkingLabel() {
    return translatedVariants('default')[0] || 'Thinking...';
}
export function resolveThoughtLabel(thoughtKey, message, randomSource = Math.random) {
    if (isThoughtKey(thoughtKey)) {
        const label = pickVariant(translatedVariants(thoughtLabelKeys[thoughtKey]), randomSource);
        if (label)
            return label;
    }
    return normalizeLabel(message) || defaultThinkingLabel();
}
